import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from 'react';
import { ICustomerSelection } from '../../domains/common/types';

interface CustomerSelectionContextValue {
  isVisible: boolean;
  customers: Array<ICustomerSelection>;
  requireSelection: (customers: Array<ICustomerSelection>) => void;
}

const CustomerSelectionContext = createContext<
  CustomerSelectionContextValue | undefined
>(undefined);

export const CustomerSelectionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [customers, setCustomers] = useState<Array<ICustomerSelection>>([]);

  const requireSelection = useCallback(
    (newCustomers: Array<ICustomerSelection>) => {
      setCustomers(newCustomers);
      setIsVisible(true);
    },
    []
  );

  return (
    <CustomerSelectionContext.Provider
      value={{ isVisible, customers, requireSelection }}
    >
      {children}
    </CustomerSelectionContext.Provider>
  );
};

export const useCustomerSelection = () => {
  const context = useContext(CustomerSelectionContext);
  if (!context)
    throw new Error(
      'useCustomerSelection must be used within CustomerSelectionProvider'
    );
  return context;
};
